var breakpoints = {
    phone: 320,
    tablet: 768,
    desktop: 1280,
    desktopLarge: 1920,
    desktopExtraLarge: 2560,
    desktopUltraWideLarge: 5120
};

module.exports = {
    values: breakpoints
};
